module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="choose-recipients-list-item"></div>\n<div class="choose-recipients-list-item-remove-button"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/share/ShareRecipientView.tpl
// module id = 2914
// module chunks = 0